import { apolloRichTextSchema } from '@ecomm/contentful-schemas'
import { type TypeOf, z } from '@simplisafe/ewok'

import {
  type ContentfulImageSchema,
  contentfulImageSchema
} from '@ecomm/contentful/components'

const ctflImageToGatsbyImage = (obj: ContentfulImageSchema) => {
  return {
    description: obj.description,
    title: obj.description,
    gatsbyImageData: {
      height: obj.originalHeight,
      width: obj.originalWidth,
      images: {
        fallback: {
          src: obj.url
        }
      },
      layout: 'constrained'
    },
    mimeType: 'image/webp'
  }
}

export const carouselSchema = z
  .object({
    __typename: z.literal('CarouselWrap'),
    sys: z.object({
      id: z.string()
    }),
    title: z.string(),
    description: apolloRichTextSchema.optional(),
    name: z.string().optional(),
    itemsCollection: z.object({
      items: z
        .object({
          headline: z.string(),
          image: contentfulImageSchema,
          description: apolloRichTextSchema
        })
        .array()
    })
  })
  //This must be removed after we move to apollo in the FloorPlanCarousel component
  .transform(vals => ({
    ...vals,
    description: {
      raw: vals.description?.json ? JSON.stringify(vals.description?.json) : ''
    },
    id: vals.sys.id,
    items: vals.itemsCollection.items.map(i => ({
      ...i,
      image: ctflImageToGatsbyImage(i.image),
      description: {
        raw: i.description?.json ? JSON.stringify(i.description?.json) : ''
      }
    }))
  }))

const apolloAnchorSectionFeatureSection = z
  .object({
    __typename: z.literal('Section'),
    body: apolloRichTextSchema,
    media: contentfulImageSchema,
    type: z
      .enum([
        'Right Side Media',
        'Left Side Media',
        'Background Media Text on the Right',
        'Background Media Text on the Left',
        'Background Media Centered Text'
      ])
      .optional(),
    theme: z.enum(['Default', 'Gray', 'Brand Primary']).optional().nullish()
  })
  //This must be removed after we move to apollo in the FeatureSection component
  .transform(vals => ({
    ...vals,
    body: {
      raw: vals.body?.json ? JSON.stringify(vals.body?.json) : ''
    },
    media: ctflImageToGatsbyImage(vals.media)
  }))

export const anchorSectionSchema = z.object({
  __typename: z.literal('AnchorSection'),
  name: z.string(),
  component: z.union([carouselSchema, apolloAnchorSectionFeatureSection]),
  classNames: z.string().optional()
})

export type AnchorSectionSchema = TypeOf<typeof anchorSectionSchema>
